import { LoadingBox, Popup } from "component/basic/popup";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const PublicOnly = () => {
    const navigate = useNavigate();
    const param = useParams();
    const errNumber = param.err;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [popupData,setPopupData] =  useState(null);

    useEffect(() => {
        if(!localStorage.getItem("token") && window.location.pathname !== "/pageErr"){
            // navigate(0);
        }
    }, []);

    useEffect(() => {
        setPopupData({
            addClass:null,
            title:errNumber ? `${errNumber} Error` : "서비스 이용에 불편을 드려 죄송합니다.",
            text:errNumber ? "서비스 이용에 불편을 드려 죄송합니다.<br/>서비스 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요" : "페이지가 없거나, 서비스 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요",
            closeType:false,
            closeFunc:(e) => {},
            btnFunc0:(e)=>{
                navigate("/")
            },
            btn0:"처음으로",
            btn0Type:"",
            btn1:"",
            btn1Type:"",
            btnFunc1:()=>{}
        });
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <Popup
                data={popupData}
            />
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default PublicOnly;